import { Launch } from "@mui/icons-material";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { EditActionCell } from "../../components/DataTable/customcell/EditActionCell";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { RootState } from "../../store";
import {
  CompositeFilterDescriptor,
  DataResult,
  process,
} from "@progress/kendo-data-query";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { DataGrid } from "../../components/DataTable/DataGrid";
import {
  getHarvestPriceData,
  getRateTypes,
} from "../../slices/productcostseeds.slice";
import { GridColumnProps } from "@progress/kendo-react-grid";
import { fetchCropTypes } from "../../slices/productcostapplication.slice";
import { EditHarvestPriceModal } from "./EditHarvestPriceModal";

const initialFilters: CompositeFilterDescriptor = {
  logic: "and",
  filters: [],
};

export const Harvest = () => {
  const dispatch = useAppDispatch();
  const [filter, setFilter] =
    useState<CompositeFilterDescriptor>(initialFilters);
  const exportRef = useRef<ExcelExport | null>(null);
  const { harvestPrices, rateTypesArray } = useAppSelector(
    (state: RootState) => state.seedsdropdown
  );
  const [selectedRateType, setSelectedRateType] = useState<string>("All");
  const [selectedCrop, setSelectedCrop] = useState<string>("All");
  const { cropTypesArray } = useAppSelector(
    (state: RootState) => state.applicationdropdown
  );

  const [open, setOpen] = useState(false);
  const [editItem, setEditItem] = useState<any>(null);

  const onEditClick = (dataItem: any) => {
    setEditItem(dataItem);
    setOpen(true);
  };

  const gridColumns: GridColumnProps[] = [
    {
      field: "cropName",
      title: "Crop Name",
      width: "180px",
    },
    {
      field: "rateType",
      title: "Rate Type",
      width: "180px",
    },
    {
      field: "harvestPrices",
      title: "Harvest Price",
      width: "250px",
    },
    {
      field: "haulingPrices",
      title: "Hauling Price",
      width: "250px",
    },
    {
      field: "haulingOveragePrices",
      title: "Hauling Overage Price",
      width: "250px",
    },
    // {
    //   field: "harvestPrice",
    //   title: "Harvest Price",
    //   format: "{0:c}",
    //   width: "120px",
    // },
    // {
    //   field: "haulingPrice",
    //   title: "Hauling Price",
    //   format: "{0:c}",
    //   width: "120px",
    // },
    // {
    //   field: "haulingOveragePrice",
    //   title: "Hauling Overage",
    //   format: "{0:c}",
    //   width: "180px",
    // },
    {
      title: "Actions",
      width: "100px",
      cells: {
        data: (props: any) => (
          <EditActionCell {...props} onEditClick={onEditClick} />
        ),
      },
    },
  ];

  useEffect(() => {
    dispatch(getHarvestPriceData());
    dispatch(getRateTypes());
    dispatch(fetchCropTypes({}));
  }, []);

  useEffect(() => {
    if (selectedCrop || selectedRateType) {
      const filterObj: CompositeFilterDescriptor = {
        logic: "and",
        filters: [],
      };
      if (selectedRateType !== "All") {
        filterObj.filters.push({
          field: "rateType",
          operator: "eq",
          value: selectedRateType,
        });
      }
      if (selectedCrop !== "All") {
        filterObj.filters.push({
          field: "cropName",
          operator: "contains",
          value: selectedCrop,
        });
      }
      setFilter(filterObj);
    } else {
      setFilter(initialFilters);
    }
  }, [selectedCrop, selectedRateType]);

  const handleClose = () => {
    dispatch(getHarvestPriceData());
    setOpen(false);
  };

  const excelExport = () => {
    if (exportRef.current !== null) {
      const processedData: DataResult = process(harvestPrices, {
        filter: filter,
      });
      exportRef.current.save(processedData);
    }
  };

  return (
    <Box display={"flex"} p={3} gap={2} flexDirection={"column"}>
      <Box display={"flex"} gap={2}>
        <FormControl>
          <InputLabel>Crop</InputLabel>
          <Select
            label="Crop"
            value={selectedCrop}
            onChange={(e: SelectChangeEvent) => setSelectedCrop(e.target.value)}
            size="small"
            sx={{ minWidth: "200px" }}
          >
            <MenuItem value="All">All</MenuItem>
            {cropTypesArray.map((cropType) => (
              <MenuItem key={cropType.id} value={cropType.cropName}>
                {cropType.cropName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl>
          <InputLabel>Rate Type</InputLabel>
          <Select
            label="Rate Type"
            value={selectedRateType}
            onChange={(e: SelectChangeEvent) =>
              setSelectedRateType(e.target.value)
            }
            size="small"
            sx={{ minWidth: "200px" }}
          >
            <MenuItem value="All">All</MenuItem>
            {rateTypesArray.map((rateObj) => (
              <MenuItem key={rateObj.id} value={rateObj.name}>
                {rateObj.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          startIcon={<Launch />}
          onClick={excelExport}
        >
          Export
        </Button>
      </Box>
      <Box>
        <DataGrid
          ref={exportRef}
          data={harvestPrices}
          dataItemKey="id"
          filter={filter}
          columns={gridColumns}
        />
      </Box>
      {open && (
        <EditHarvestPriceModal
          open={open}
          handleClose={handleClose}
          editItem={editItem}
        />
      )}
    </Box>
  );
};
